module.exports = __webpack_public_path__ + "static/media/partners_allison.f3c6cec9.jpg";